import { useTenderDeadline } from "../../../../../hooks/useTenderDeadline";
import React from "react";
import { useSelector } from "react-redux";
import style from "./ActionsTab.module.scss";
import TenderDeadlineInfo from "../../../order-info/components/TenderDeadlineInfo";
import ListSuggestedPricesNew from "../ListSuggestedPricesNew";
import ComplexTenderBids from "../ComplexTenderBids/ComplexTenderBids";
import OrderCreatedCard from "../OrderCreatedCard";
import OrderStatusTimeline from "../OrderStatusTimeline";
import InsuranceStatus from "../InsuranceStatus/InsuranceStatus";
import OrderActionHint from "./OrderActionHint";
import { useTranslation } from "react-i18next";

const ActionsTab = ({
  order,
  cargoDetails,
  fetchOrderData,
  onForceUpdate,
  statusHistory = [],
  listSuggestedPrice = [],
  complexTenderPrices = [],
  driverPrices = [],
  complexTenderBids = [],
  onClose,
}) => {
  const { isExpired: isTenderExpiredByServer } = useTenderDeadline(order?.tenderDateEnd, { inclusive: true });
  const { t } = useTranslation();
  const { user } = useSelector((state) => state);
  const company = useSelector((state) => state.user.company);

  if (!order) return null;

  const isOwnCompany = order.companyId === company?.id;
  const isAwaitingOffer = order.status === "awaitingoffer";
  const hasSuggestedPrices = order?.isComplexTender
    ? complexTenderBids.length > 0
    : listSuggestedPrice.length > 0 || complexTenderPrices.length > 0 || driverPrices.length > 0;
  const isTenderExpired = order?.tenderDateEnd ? isTenderExpiredByServer : false;

  if (!isAwaitingOffer) {
    const bids = order?.isComplexTender
      ? complexTenderBids
      : [...listSuggestedPrice, ...driverPrices];
    return (
      <div className={style.wrapper}>
        {order?.insuranceIncluded && <InsuranceStatus orderId={order.id} />}

        <OrderStatusTimeline
          order={order}
          statusHistory={statusHistory}
          bids={bids}
          fetchOrderData={fetchOrderData}
          onForceUpdate={onForceUpdate}
        />
      </div>
    );
  }

  return (
    <div className={style.wrapper}>
      {order?.insuranceIncluded && <InsuranceStatus orderId={order.id} />}

      <OrderCreatedCard order={order} />

      {isOwnCompany && order?.isComplexTender && (
        <ComplexTenderBids
          order={order}
          items={complexTenderBids}
          fetchOrderData={fetchOrderData}
          onUpdateData={() => onForceUpdate?.()}
          onClose={onClose}
        />
      )}

      {isOwnCompany && !order?.isComplexTender && listSuggestedPrice.length > 0 && (
        <ListSuggestedPricesNew
          title="orderInfoClient.suggestedPrices.defaultTitle"
          orderData={order}
          items={listSuggestedPrice}
          fetchOrderData={fetchOrderData}
          ordersStatus={order?.status}
          onUpdateData={() => onForceUpdate?.()}
          isPublic={order?.isPublic ? order?.isPublic : false}
          user={user}
          tenderDateEnd={order?.tenderDateEnd}
          cargoDetails={cargoDetails}
        />
      )}

      {isOwnCompany && !order?.isComplexTender && driverPrices.length > 0 && (
        <ListSuggestedPricesNew
          title="orderInfoClient.suggestedPrices.driverTitle"
          items={driverPrices}
          fetchOrderData={fetchOrderData}
          ordersStatus={order?.status}
          onUpdateData={() => onForceUpdate?.()}
          user={user}
          tenderDateEnd={order?.tenderDateEnd}
          cargoDetails={cargoDetails}
          isMarketSuggested
          orderData={order}
          isDriverSuggested
        />
      )}

      {isOwnCompany && hasSuggestedPrices && isTenderExpired && (
        <OrderActionHint
          text={t(
            order?.assignmentMethod === "Auction"
              ? "orderInfoClient.suggestedPrices.auctionCompletedSelectWinner"
              : "orderInfoClient.suggestedPrices.tenderCompletedSelectWinner",
          )}
        />
      )}

      {user?.type === "Client" &&
        order?.tenderDateEnd &&
        !order?.isComplexTender &&
        !hasSuggestedPrices && <TenderDeadlineInfo item={order} />}
        
      {isOwnCompany && !hasSuggestedPrices && isTenderExpired && (
        <OrderActionHint text={t("orderInfoClient.suggestedPrices.tenderCompletedExtendOrDelete")} withoutBorder />
      )}
    </div>
  );
};

export default ActionsTab;
